__turbopack_context__.v({
  "actionCard": "ItemPage-module-scss-module__FzRq-q__actionCard",
  "assignmentWidgetDesktop": "ItemPage-module-scss-module__FzRq-q__assignmentWidgetDesktop",
  "assignmentWidgetMobile": "ItemPage-module-scss-module__FzRq-q__assignmentWidgetMobile",
  "deliveryInfo": "ItemPage-module-scss-module__FzRq-q__deliveryInfo",
  "fade-in": "ItemPage-module-scss-module__FzRq-q__fade-in",
  "infoAside": "ItemPage-module-scss-module__FzRq-q__infoAside",
  "infoSection": "ItemPage-module-scss-module__FzRq-q__infoSection",
  "infoSectionContent": "ItemPage-module-scss-module__FzRq-q__infoSectionContent",
  "infoSectionDescription": "ItemPage-module-scss-module__FzRq-q__infoSectionDescription",
  "itemPage": "ItemPage-module-scss-module__FzRq-q__itemPage",
  "main": "ItemPage-module-scss-module__FzRq-q__main",
  "no-transform": "ItemPage-module-scss-module__FzRq-q__no-transform",
  "pageSection": "ItemPage-module-scss-module__FzRq-q__pageSection",
  "relatedContent": "ItemPage-module-scss-module__FzRq-q__relatedContent",
  "rotate": "ItemPage-module-scss-module__FzRq-q__rotate",
  "section": "ItemPage-module-scss-module__FzRq-q__section",
  "sellerCard": "ItemPage-module-scss-module__FzRq-q__sellerCard",
  "subHeading": "ItemPage-module-scss-module__FzRq-q__subHeading",
  "usp": "ItemPage-module-scss-module__FzRq-q__usp",
  "uspItem": "ItemPage-module-scss-module__FzRq-q__uspItem",
});
